import { defineComponent as _defineComponent } from 'vue'
import BuyBoxUpcomingNew, { UpcomingReleaseBuybox } from '@/components/buybox-new/BuyBoxUpcomingNew.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { BuyBoxFilterOptions } from '@/stores/user.store';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { OfferLocation, trackClickOutGraphql } from '@/helpers/offer-helper';
import { TitleOfferFragment } from '../buybox/graphql/fragments/Offer.fragment';
import BuyBoxNoOffersNew from '@/components/buybox-new/BuyBoxNoOffersNew.vue';
import BuyBoxNotifyMeNew from '@/components/buybox-new/BuyBoxNotifyMeNew.vue';
import BuyBoxPromotionRowNew from './BuyBoxPromotionRowNew.vue';
import { computed } from 'vue';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { allowedPromotionLanguages, usePromotion } from '@/helpers/composables/usePromotion';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxUpcomingWithNoOffers',
  props: {
    upcomingReleases: null,
    title: null,
    isTitleInWatchlist: { type: Boolean },
    filter: null,
    additionalContexts: null
  },
  emits: ["clickOut", "onNotifyMe"],
  setup(__props: any, { emit }: { emit: ({
	(
		e: 'clickOut',
		data: {
			buyboxOffer: TitleOfferFragment & { iconUrl?: string; bundleId?: number };
			isBundle: boolean;
			isLeavingIconShown?: boolean;
			evt: MouseEvent;
		}
	): void;
	(e: 'onNotifyMe'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	upcomingReleases: UpcomingReleaseBuybox[];
	title: TitleDetail;
	isTitleInWatchlist?: boolean;
	filter: BuyBoxFilterOptions;
	additionalContexts: SnowplowContext[];
};





const { language } = useLanguageStore();

const { promotionOffer } = usePromotion({
	title: () => props.title,
	offers: () => [],
});

const showFreeTrial = computed(
	() =>
		!!promotionOffer.value &&
		[BuyBoxFilterOptions.ALL, BuyBoxFilterOptions.FREE, BuyBoxFilterOptions.SUBSCRIPTION].includes(props.filter) &&
		// splitting language for locale specific ones like Spanish - Spain, Spanish - Latin America, etc
		allowedPromotionLanguages.includes(language.value.split('-')[0])
);

const clickOut = (payload: {
	buyboxOffer: TitleOfferFragment | null;
	offerLocation: OfferLocation.FREE_TRIAL;
	row: HTMLElement | null;
}) => {
	if (!payload.buyboxOffer) return;
	let _offer = payload.buyboxOffer;
	const titleObjectId = props.title.objectId;
	const titleObjectType = props.title.objectType;

	trackClickOutGraphql({
		offer: _offer,
		objectType: titleObjectType,
		objectId: titleObjectId,
		offerLocation: OfferLocation.REGULAR_BUYBOX,
		additionalContexts: props.additionalContexts,
		contentType: undefined,
	});
};

return { __sfc: true,props, emit, language, promotionOffer, showFreeTrial, clickOut, BuyBoxUpcomingNew, BuyBoxNoOffersNew, BuyBoxNotifyMeNew, BuyBoxPromotionRowNew }
}

})